module.exports = __webpack_public_path__ + "img/qcsy.f631e9a6.jpg";